'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColoring = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColoring = exports.getColoring = (0, _get2.default)('coloring');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/getColoring.js
// module id = 528
// module chunks = 2 3